import ProjectSettings from "../../manager/project/project-settings/project-settings"
import {SESSION_PROJECT_CHANGE, SESSION_PROJECT_SETTINGS_CHANGE} from "../../gd/bus/bus-event-type"
import SessionEventProto from "../session-event-proto"

const debug = false
// const debug = "SessionProjectDelta"

export default class SessionProjectDelta extends SessionEventProto {

    public header: {
        project     : any
        isBulkUpdate: boolean
    }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.header     = {
            project     : sessionEvent.project,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
    }

    async process() {
        if (this.isDifferentCompany()) return false;

        this._updatePin()                   // gd.session.pins
        this._updateSessionCollection()     // gd.session.projects
        this._updateTemplatesCollection()   // gd.session.templatesList
        await this._updateProjectSettings()
        this._sendBusUpdate()
    }

    _updatePin() {
        const pinId = gd.session.pins.getPinId({projectId:this.header.project.id})
        if (pinId) {
            const pin = gd.session.pins.get(pinId)
            if (!pin?.project) return

            if (this.data.name)         pin.project.name        = this.data.name
            if (this.data.color)        pin.project.color       = this.data.color
            if (this.data.systemType)   pin.project.systemType  = this.data.systemType
        }
    }

    _updateSessionCollection() {
        const sessionProject = gd.session.projects.get(this.header.project.id)
        if (!sessionProject) return

        let needResetTree = false

        // make sure we update only fields we have in session model in future (!)
        sessionProject.applyDelta(this.data)

        if (sessionProject.isTag) {
            gd.fields.resetTagsFields()
        }

        _.map(_.keys(this.data), fieldName=>{

            debug && console.log(debug, "_updateSessionCollection", fieldName, this.data[fieldName])

            // these are the fields that we used to deal with via project.change event before
            if (['systemStatus','statusId','name','color','projectIcon', 'parentId', 'sortPosition'
                ,'settings', 'systemType', 'customFields','taskTypes','statuses'
                ,'localTemplateId','sharedTemplateId', 'templateContent'
                ,'taskStatusesOverride', 'properties'
                ,'customFields', 'isTemplate','description',
                'isDeleted'
            ].includes(fieldName)) {
                needResetTree = true
            }

            // eto po idee nuzno no potom i vozmozno cherez projectSessionModel ?
            // ya dumau eto toka dlya new nuzno hotya hez mozet i statuses

            // let statuses = this.data.taskStatusesOverride ? this.data.taskStatusesOverride : [];
            // let sessionLoader = new SessionLoader();
            // sessionLoader.process(gd.session.findMissing({
            //     projects: [this.data.localTemplateId],
            //     statuses: statuses
            // }));
            //
            // sessionLoader.done(()=>{
            //     // let's recreate the tree ?
            //     gd.tree.resetCompanyProjects(sessionProject.companyId);
            // })
        })

        if (sessionProject.isWorkspace) {
            gd.spaces.workspaces.initFromSession()
            const workspace = gd.spaces.workspaces.getByProjectId(sessionProject.id)
            if (workspace) {
                workspace.initNavigation()
                workspace.updateTitleAndIcon()
            }
        }

        // yes trigger via bus ... as we start using bus only here we use it to update title in project header (project title)
        gd.bus.triggerEvent(SESSION_PROJECT_CHANGE,this.header.project.id);

        if (needResetTree) {
            gd.tree.resetCompanyProjects(gd.companyId);
        }
    }

    _updateTemplatesCollection() {
        // ok which fields do we care about ?
        // systemStatus - skip
        // statusId - skip

        const sessionTemplate = gd.session.templatesList.get(this.header.project.id);
        if (!sessionTemplate) return;

        debug && console.log(debug, "_updateTemplatesCollection sessionTemplate", sessionTemplate)

        sessionTemplate.applyDelta(this.data)

        /*// make sure we update only fields we have in session model in future (!)
        _.map(_.keys(this.data), fieldName=>{
            debug && console.log(debug, "_updateTemplatesCollection", fieldName, this.data[fieldName])

            // these are the fields that we used to deal with via project.change event before
            if (['name', 'color', 'systemType', 'shortName', 'customFields', 'taskTypes',
            'taskStatusesOverride', 'sharedTemplateId', 'templateContent', 'statuses', 'projectIcon',
            'description', 'isDeleted'].includes(fieldName)) {
                sessionTemplate.set(fieldName, this.data[fieldName],{silent:true, parse:true});
            }
        })*/

        /*sessionTemplate.set({
            name:                   this.data.name,
            color:                  this.data.color,
            icon:                   this.data.icon,
            // systemStatus:           this.data.systemStatus,
            systemType:             this.data.systemType,
            parentId:               this.data.parentId,
            shortName:              this.data.shortName,
            // statusId:               this.data.statusId,
            customFields:           this.data.customFields,
            taskTypes:              this.data.taskTypes,
            // projectTypeId:          this.data.projectTypeId,
            // defaultView:            this.data.defaultView,
            // properties:             ProjectPropertiesData.normalize(this.data.properties),
            taskStatusesOverride:   this.data.taskStatusesOverride,
            sharedTemplateId:       this.data.sharedTemplateId,
            templateContent:        this.data.templateContent,
            statuses:               this.data.statuses,
            projectIcon:            this.data.projectIcon,
            description:            this.data.description,
            isDeleted:              this.data.isDeleted
        },{silent:true, parse:true});*/

        // sessionTemplate.trigger("change", sessionTemplate);
    }

    async _updateProjectSettings() {
        if (this.data.hasOwnProperty('settings')) {
            const sessionProject = gd.session.projects.get(this.header.project.id)
            if (sessionProject) {
                sessionProject.applyDelta({settings: new ProjectSettings(sessionProject, this.data.settings)})

                // update project views if delta is for project currently viewed
                if (gd.projectViews?.project.id=== this.header.project.id) {
                    await gd.projectViews.onProjectSettingsChanged(this.header.project.id)
                }

                gd.bus.triggerEvent(SESSION_PROJECT_SETTINGS_CHANGE, this.header.project.id)
            }
        }
    }

    _sendBusUpdate() {
        // send
        gd.modelBus.newUpdate('project', this.method, this.header.project.id, this.data, this.header)
    }
}
